import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API, auth, exportExcel, printArea, PrintStyle } from '../shared';
import KpiCard from '../KpiCard';
import ReportActions from '../ReportActions';
import { EmptyState } from '../../../../components/dashboard/TodaySchedule';

export default function CoachingTab({ filters }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setDenied(false);
      try {
        const res = await axios.get(`${API}/coach-studio/org/reports?date_from=${filters.date_from}&date_to=${filters.date_to}`, auth());
        setData(res.data);
      } catch (err) {
        if (err?.response?.status === 403) setDenied(true);
        setData(null);
      }
      setLoading(false);
    })();
  }, [filters.date_from, filters.date_to]);

  if (loading) {
    return <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">{[1, 2, 3, 4].map((i) => <div key={i} className="h-24 animate-pulse rounded-xl bg-slate-100" />)}</div>;
  }
  if (denied) {
    return <div className="rounded-xl border border-red-200 bg-red-50 py-10 text-center text-sm text-red-700" data-testid="coaching-denied">لا تملك صلاحية الاطلاع على تقارير العمل الفني</div>;
  }

  const rows = data ? [{ 'الجلسات المشتركة': data.shared_sessions_total, 'مجدولة': data.sessions_scheduled, 'مكتملة': data.sessions_completed, 'ملغاة': data.sessions_cancelled, 'عدد المدربين': data.coaches_involved }] : [];

  return (
    <div className="space-y-4 print-area" data-testid="coaching-tab">
      <PrintStyle />
      <div className="flex justify-end print:hidden">
        <ReportActions testId="coaching-report" onExcel={() => exportExcel(rows, 'تقرير-العمل-الفني')} onPrint={printArea} disabled={rows.length === 0} />
      </div>
      {!data || data.shared_sessions_total === 0 ? (
        <EmptyState icon="whistle" text="لا توجد جلسات تدريبية مشتركة مع المنشأة في هذه الفترة" testId="coaching-empty" />
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          <KpiCard icon="whistle" label="جلسات مشتركة" value={data.shared_sessions_total} testId="kpi-coach-total" />
          <KpiCard icon="calendar" label="مجدولة" value={data.sessions_scheduled} testId="kpi-coach-scheduled" />
          <KpiCard icon="check" label="مكتملة" value={data.sessions_completed} accent="text-teal-700" testId="kpi-coach-completed" />
          <KpiCard icon="x" label="ملغاة" value={data.sessions_cancelled} accent="text-red-600" testId="kpi-coach-cancelled" />
          <KpiCard icon="users" label="عدد المدربين" value={data.coaches_involved} testId="kpi-coach-count" />
        </div>
      )}
    </div>
  );
}
